import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-box',
  templateUrl: './default-box.component.html',
  styleUrls: ['./default-box.component.scss']
})
export class DefaultBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
